import React from "react";
import { Link } from "react-router-dom";

const ClosingCTA = () => {
  return (
    <section className="relative overflow-hidden">
      <img
        src="/hero-slide.png"
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-[70%_center]"
      />
      <div className="absolute inset-0 bg-espresso/75" />
      <div className="relative mx-auto flex min-h-[22rem] max-w-4xl flex-col items-center justify-center px-5 py-20 text-center text-cream md:min-h-[26rem]">
        <h2 className="font-display text-3xl leading-tight md:text-5xl">
          Ready to Experience Rwanda&apos;s Finest Coffee?
        </h2>
        <p className="mt-4 max-w-xl text-cream/80">
          Fresh single-origin Arabica from Rulindo, Kamonyi, or Karongi—roasted weekly and delivered with purpose.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/product"
            className="rounded-md bg-gold px-8 py-3.5 text-sm font-semibold text-espresso transition hover:bg-gold-light"
          >
            Shop Coffee
          </Link>
          <Link
            to="/contact"
            className="rounded-md border border-cream px-8 py-3.5 text-sm font-semibold text-cream transition hover:bg-cream/10"
          >
            Become a Wholesale Partner
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ClosingCTA;
